import settingsCodeList from './kr/settingsCodeList.json';

export const MockConfig = {
    ['/auth/settings/code/list']: () => settingsCodeList,
};
